/**
 * Scrollable Image Gallery Component
 * Handles auto-scrolling functionality
 */
(function() {
  'use strict';

  class ScrollableImageGallery extends HTMLElement {
    constructor() {
      super();
      this.track = null;
      this.scrollSpeed = 30;
      this.scrollDirection = 'left';
    }

    connectedCallback() {
      this.track = this.querySelector('[data-gallery-track]');
      if (!this.track) return;

      // Get settings from data attributes
      this.scrollSpeed = parseInt(this.getAttribute('data-scroll-speed'), 10) || 30;
      this.scrollDirection = this.getAttribute('data-scroll-direction') || 'left';

      // Set up animation direction
      this.track.setAttribute('data-scroll-direction', this.scrollDirection);

      // Ensure smooth animation
      this.track.style.willChange = 'transform';
    }
  }

  // Register the custom element
  if (!customElements.get('scrollable-image-gallery')) {
    customElements.define('scrollable-image-gallery', ScrollableImageGallery);
  }

  // Handle theme editor events
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      const gallery = event.target.querySelector('scrollable-image-gallery');
      if (gallery && gallery.connectedCallback) {
        // Reinitialize gallery when section is loaded in editor
        setTimeout(function() {
          gallery.connectedCallback();
        }, 100);
      }
    });
  }
})();
